import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M17.4118 11.7206H14M17.4118 11.7206L17.9839 11.8477C19.1189 12.1 19.9265 13.1066 19.9265 14.2693C19.9265 15.6394 18.8158 16.75 17.4458 16.75H14C14 16.75 14 14.439 14 11.7206M17.4118 11.7206C18.3792 11.5594 19.0882 10.7223 19.0882 9.74158V9.51902C19.0882 8.26588 18.0724 7.25 16.8192 7.25H14C14 8.55783 14 10.2406 14 11.7206" vectorEffect="non-scaling-stroke" />
		<Path d="M4.25 17.5V17.223L5.26577 14.1757M5.26577 14.1757L7.57432 7.25H8.12838L10.4369 14.1757L11.4527 17.223V17.5M10.4369 14.1757H5.26577" vectorEffect="non-scaling-stroke" />
	</SVG>
);
